import { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { fetchWithAuth } from '../utils/fetchWithAuth'
import Overlay from './Overlay'
import MessageBox from './MessageBox'
import { EUROPEAN_COUNTRY_CODES } from '../constants/europeanCountries'
import QRModal from './QRModal'
import ChangePasswordModal from './ChangePasswordModal'
import MFAModal from './MFAModal'
import {
  modalPrimaryButtonStyle,
  modalSecondaryButtonStyle
} from '../styles/buttonStyles'

const LABEL_W = 170
const INPUT_W = 320
const INPUT_H = 20

const Row = ({ htmlFor, label, children }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <label
      htmlFor={htmlFor}
      style={{
        width: LABEL_W,
        fontWeight: 700,
        fontSize: 17
      }}
    >
      {label}
    </label>
    <div style={{ display: 'flex', alignItems: 'center', width: INPUT_W }}>
      {children}
    </div>
  </div>
)

const inputStyle = {
  height: INPUT_H,
  fontSize: 16,
  padding: '6px 10px',
  borderRadius: 6,
  border: '1px solid #999',
  width: '100%'
}

const PersonalDataModal = ({ open, onClose }) => {
const getCountryLabel = (code) => {
  if (!code) return ''
  const name = t(code)
  const resolved = name && name !== code ? name : code
  return `${code} - ${resolved}`
}
  const { t, i18n } = useTranslation()

  const [form, setForm] = useState({})
  const [original, setOriginal] = useState({})
  const [message, setMessage] = useState(null)
  const [loading, setLoading] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [showQR, setShowQR] = useState(false)
const [pressedBtn, setPressedBtn] = useState(null)
const [hoverBtn, setHoverBtn] = useState(null)
const [referralsCount, setReferralsCount] = useState(0)
const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)
const [showMfaModal, setShowMfaModal] = useState(false)

const isReferralMaxed = referralsCount >= 5
//const isReferralMaxed = true

  const updateForm = (k, v) =>
    setForm(prev => ({ ...prev, [k]: v }))

const loadProfile = useCallback(async () => {
  try {
    setLoading(true)

    const res = await fetchWithAuth('/auth/me', {
      headers: { 'Accept-Language': i18n.language }
    })
    if (!res.ok) return
    const data = await res.json().catch(() => null)
    if (!data) return

    const user = data?.user || data
    setForm(user)
    setOriginal(user)

    // načítanie networku
    const netRes = await fetchWithAuth(`/referral/network/${user.id}`)
    if (netRes.ok) {
      const network = await netRes.json()

      const level1Count = Array.isArray(network)
        ? network.filter(n => n.generation === 1).length
        : 0

      setReferralsCount(level1Count)
    }

  } finally {
    setLoading(false)
  }
}, [i18n.language])

  useEffect(() => {
    if (!open) return

    loadProfile()
    setEditMode(false)
    setMessage(null)

const handleEsc = (e) => {
  if (e.key !== 'Escape') return

if (showQR) {
  setShowQR(false)
  return
}

if (showChangePasswordModal || showMfaModal) {
  return
}

onClose()
}

    window.addEventListener('keydown', handleEsc)
    return () => window.removeEventListener('keydown', handleEsc)
  }, [open, loadProfile, onClose, showQR, showChangePasswordModal, showMfaModal])

  const saveProfile = async () => {
    try {
      setLoading(true)

      const res = await fetchWithAuth('/auth/me', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': i18n.language
        },
        body: JSON.stringify(form)
      })

if (res.status === 0) {
  setMessage({ message: t('SERVER-ERROR'), type: 'error' })
  return
}

if (!res.ok) {
  setMessage({ message: t('SAVE_ERROR'), type: 'error' })
  return
}

      setOriginal(form)
      setEditMode(false)
      setMessage({ message: t('SAVED'), type: 'success' })

    } catch {
      setMessage({ message: t('CONNECTION_ERROR'), type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  const updateMfaStatus = (enabled) => {
    setForm(prev => ({ ...prev, mfa_enabled: enabled }))
    setOriginal(prev => ({ ...prev, mfa_enabled: enabled }))
  }

  if (!open) return null

  return (
    <>
      <Overlay open={loading} zIndex={4000} backdropOpacity={0.75} />

      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 3000
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            background: '#ededed',
            padding: '5px 30px 15px 30px',
            border: '2px solid #107c6b',
            borderRadius: 14,
            boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
            maxHeight: '90vh',
            overflowY: 'visible',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: LABEL_W + INPUT_W + 40
          }}
        >
          <h3 style={{ fontSize: 24, marginTop: 5, marginBottom: 20 }}>
            {t(form.account_type === 'company' ? 'COMPANY_PROFILE' : 'USER_PROFILE')}
          </h3>

          {message && (
            <MessageBox message={message.message} type={message.type} />
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>

            {/* REFERRAL ROW */}
            <Row htmlFor="referral_code" label={t('REFERRAL_CODE')}>
              <div style={{ display: 'flex', width: '100%', gap: 8 }}>
                <input
                  id="referral_code"
                  value={form.referral_code || ''}
                  disabled
                  style={{
                    ...inputStyle,
                    width: '75%',
                    background: '#ddd'
                  }}
                />
		<button
  		style={{
  		  ...modalPrimaryButtonStyle(
 		     pressedBtn,
  		    'qr',
 		     hoverBtn === 'qr'
		    ),
 		   width: '25%',
  		  height: 33,
  		  borderRadius: 6
		  }}
		  onMouseEnter={() => setHoverBtn('qr')}
		  onMouseLeave={() => {
		    setHoverBtn(null)
		    setPressedBtn(null)
		  }}
		  onMouseDown={() => setPressedBtn('qr')}
 		 onMouseUp={() => setPressedBtn(null)}
 		 onClick={() => setShowQR(true)}
		>
		  {t('QR')}
		</button>
              </div>
            </Row>

            {[
              ['meno', 'FIRST_NAME'],
              ['priezvisko', 'LAST_NAME'],
              ['email', 'EMAIL'],
              ['telefon', 'PHONE'],
              ...(form.account_type === 'company'
                ? [
                    ['company_name', 'REG_COMPANY_NAME'],
                    ['company_ico', 'REG_COMPANY_ICO'],
                    ['company_dic', 'REG_COMPANY_DIC'],
                    ['company_ic_dph', 'REG_COMPANY_VAT_ID']
                  ]
                : []),
              ['ulica', 'STREET'],
              ['mesto', 'CITY'],
              ['psc', 'ZIP'],
              ['krajina', 'COUNTRY'],
              ['iban', 'IBAN'],
              ['swift', 'SWIFT'],
              ['banka', 'BANK']
            ].map(([key, labelKey]) => (
<Row key={key} htmlFor={key} label={t(labelKey)}>
  {key === 'krajina' && false ? (
    <select
      id={key}
      value={form[key] ?? ''}
      onChange={e => updateForm(key, e.target.value)}
      style={{
        ...inputStyle,
        height: 32,
        background: '#fff'
      }}
    >
      <option value="">{t('COUNTRY')}</option>

      {EUROPEAN_COUNTRY_CODES.map(code => (
        <option key={code} value={code}>
          {getCountryLabel(code)}
        </option>
      ))}
    </select>
  ) : (
    <input
      id={key}
      value={
        key === 'krajina' && form[key]
          ? getCountryLabel(form[key])
          : (form[key] || '')
      }
      disabled={!editMode || key === 'email' || key === 'krajina'}
      onChange={e => updateForm(key, e.target.value)}
      style={{
        ...inputStyle,
        background:
          editMode && key !== 'email' && key !== 'krajina' ? '#fff' : '#ddd'
      }}
    />
  )}
</Row>
            ))}

<Row htmlFor="mfa" label={t('MFA_AUTH_APP')}>
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
    <strong style={{ flex: 1 }}>{form.mfa_enabled ? t('MFA_ENABLED') : t('MFA_DISABLED')}</strong>
    <button
      style={modalPrimaryButtonStyle(pressedBtn, 'mfa', hoverBtn === 'mfa')}
      onMouseEnter={() => setHoverBtn('mfa')}
      onMouseLeave={() => { setHoverBtn(null); setPressedBtn(null) }}
      onMouseDown={() => setPressedBtn('mfa')}
      onMouseUp={() => setPressedBtn(null)}
      onClick={() => setShowMfaModal(true)}
    >
    {t(form.mfa_enabled ? 'MFA_DISABLE' : 'MFA_ENABLE')}
    </button>
  </div>
</Row>

<div style={{ display: 'flex', gap: 12, marginTop: 15, justifyContent: 'center' }}>
  {!editMode ? (
    <>

<button
  style={modalPrimaryButtonStyle(
    pressedBtn,
    'change-password',
    hoverBtn === 'change-password'
  )}
  onMouseEnter={() => setHoverBtn('change-password')}
  onMouseLeave={() => {
    setHoverBtn(null)
    setPressedBtn(null)
  }}
  onMouseDown={() => setPressedBtn('change-password')}
  onMouseUp={() => setPressedBtn(null)}
  onClick={() => setShowChangePasswordModal(true)}
>
  {t('CHANGE_PASSWORD')}
</button>

      <button
        style={modalPrimaryButtonStyle(
          pressedBtn,
          'edit',
          hoverBtn === 'edit'
        )}
        onMouseEnter={() => setHoverBtn('edit')}
        onMouseLeave={() => {
          setHoverBtn(null)
          setPressedBtn(null)
        }}
        onMouseDown={() => setPressedBtn('edit')}
        onMouseUp={() => setPressedBtn(null)}
        onClick={() => setEditMode(true)}
      >
        {t('EDIT_PROFILE')}
      </button>

      <button
        style={modalSecondaryButtonStyle(
          pressedBtn,
          'close',
          hoverBtn === 'close'
        )}
        onMouseEnter={() => setHoverBtn('close')}
        onMouseLeave={() => {
          setHoverBtn(null)
          setPressedBtn(null)
        }}
        onMouseDown={() => setPressedBtn('close')}
        onMouseUp={() => setPressedBtn(null)}
        onClick={onClose}
      >
        {t('CLOSE')}
      </button>
    </>
  ) : (
    <>
      <button
        style={modalPrimaryButtonStyle(
          pressedBtn,
          'save',
          hoverBtn === 'save'
        )}
        onMouseEnter={() => setHoverBtn('save')}
        onMouseLeave={() => {
          setHoverBtn(null)
          setPressedBtn(null)
        }}
        onMouseDown={() => setPressedBtn('save')}
        onMouseUp={() => setPressedBtn(null)}
        onClick={saveProfile}
      >
        {t('SAVE')}
      </button>

      <button
        style={modalSecondaryButtonStyle(
          pressedBtn,
          'cancel',
          hoverBtn === 'cancel'
        )}
        onMouseEnter={() => setHoverBtn('cancel')}
        onMouseLeave={() => {
          setHoverBtn(null)
          setPressedBtn(null)
        }}
        onMouseDown={() => setPressedBtn('cancel')}
        onMouseUp={() => setPressedBtn(null)}
        onClick={() => {
          setForm(original)
          setEditMode(false)
        }}
      >
        {t('CANCEL')}
      </button>
    </>
  )}
</div>
          </div>
        </div>
      </div>

<QRModal
  open={showQR}
  referralCode={form.referral_code}
  isReferralMaxed={isReferralMaxed}
  pressedBtn={pressedBtn}
  hoverBtn={hoverBtn}
  setHoverBtn={setHoverBtn}
  setPressedBtn={setPressedBtn}
  onClose={() => setShowQR(false)}
  t={t}
/>
<ChangePasswordModal
  open={showChangePasswordModal}
  onClose={() => setShowChangePasswordModal(false)}
/>
<MFAModal
  open={showMfaModal}
  enabled={Boolean(form.mfa_enabled)}
  onClose={() => setShowMfaModal(false)}
  onStatusChange={updateMfaStatus}
/>
    </>
  )
}

export default PersonalDataModal